import PageLayout from "../../components/common/page-layout";
import ConfigMigration from "../../components/config-migration/config-migration";
import { RequireAuth } from "../../hooks/use-auth";

/**
 * Route page for the config migration internal tool. Gates access behind
 * `RequireAuth` and renders the tool inside the shared page chrome.
 */
const ConfigMigrationPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        subtitle="Copy a company's configuration between environments"
        title="Config migration"
      >
        <ConfigMigration />
      </PageLayout>
    </RequireAuth>
  );
};

export default ConfigMigrationPage;
